// extracted by mini-css-extract-plugin
export default {"slideContainer":"c999dbb93e c5469369b1 b93c04a2d6","slideImage":"fa0a3ebb41"};